import { render } from "react-dom";
import CookieDisclaimerModal from "./CookieDisclaimer";
render(
  <CookieDisclaimerModal />,
  document.getElementById("app_disclaimer_content"),
);
